import { render, staticRenderFns } from "./PrivacyTextScan.vue?vue&type=template&id=999a23c2&scoped=true"
import script from "./PrivacyTextScan.vue?vue&type=script&lang=js"
export * from "./PrivacyTextScan.vue?vue&type=script&lang=js"
import style0 from "./PrivacyTextScan.vue?vue&type=style&index=0&id=999a23c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999a23c2",
  null
  
)

export default component.exports